import React from 'react';
import styled from 'styled-components';
import { Dialog as MuiDialog, DialogProps } from '@material-ui/core';

const Dialog = styled(MuiDialog)`
  @media (max-width: 768px) {
    .MuiDialog-paper {
      margin: 0px;
      width: 100%;
      height: 100%;
    }

    .MuiDialog-paperScrollPaper {
      max-height: 100%;
    }

    .MuiDialog-paperWidthSm {
      max-width: 100%;
    }
  }
`;

export interface ResponsiveDialogProps extends DialogProps {
  // onClose is not used by this component, but is expected to be used
  // to manage whether or not the dialog is open in parent-components.
  // (parent-components: components that utilize this component)
  onClose?: () => void;
  open: boolean;
  'data-cy'?: string;
}

const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  children,
  open,
  onBackdropClick,
  ...rest
}: React.PropsWithChildren<ResponsiveDialogProps>) => {
  return (
    <Dialog
      open={open}
      onBackdropClick={onBackdropClick}
      data-cy={rest['data-cy']}
    >
      {children}
    </Dialog>
  );
};

export default ResponsiveDialog;
